const htmlEntities = require("html-entities");
module.exports = function alignText(html){
    html = htmlEntities.encode(html).replace(/&lt;/gmi, "<").replace(/&gt;/gmi, ">");
    return html;
}